/**
 * Splits a template string into an ordered list of substrings based on a
 * semantic placeholder.
 *
 * The function looks for segments enclosed by the following pattern:
 * `{placeholder}{/placeholder}`.
 *
 * Text outside the placeholder and the text captured inside it are returned
 * as separate entries in the resulting array, preserving their original order.
 *
 * Example:
 * ```ts
 * captureTextByPlaceholder(
 *   "Text to {highlight}highlight{/highlight}",
 *   "highlight"
 * );
 * // [
 * //   "Text to ",
 * //   "highlight",
 * //   ""
 * // ]
 * ```
 *
 * @param text - The template string coming from the CMS.
 * @param placeholder - The placeholder name to capture (without braces).
 * @returns An ordered array of strings, including both plain text and the
 *          content captured inside the placeholder.
 */
export const captureTextByPlaceholder = (
  text: string,
  placeholder: string
): string[] => {
  const regex = new RegExp(
    `\\{${placeholder}\\}([^\\{]*)\\{\\/${placeholder}\\}`,
    'g'
  );

  return text.split(regex);
};
